module.exports = __webpack_public_path__ + "img/SMC_title.982d0b16.png";